module.exports = __webpack_public_path__ + "img/gnt.4c11ba32.svg";